/*
Ravi 05/23/2023 3075154998 Added Export Format file Field
*/
import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  enabledSubmission: false,
};

const commonActions = createSlice({
  name: 'commonActions',
  initialState,
  reducers: {
    submissionStarted: (state, action) => {
      state.enabledSubmission = true;
    },
    submissionEnded: (state, action) => {
      state.enabledSubmission = false;
    },
  },
});

export const {submissionEnded, submissionStarted} = commonActions.actions;

export default commonActions.reducer;

export const submissionStart = () => {
  return (dispatch) => {
    dispatch(submissionStarted());
  };
};

export const submissionEnd = () => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(submissionEnded());
    }, 4000);
  };
};
